import React, { useEffect, useState } from "react";
import TermsAndConditions from "../Components/TermsAndConditions";
import goToScreen from "../lib/goToScreen";
import Loader from "../Components/Loader";
import isSiteBuilder from "../lib/isSiteBuilder";
import BackgroundPhoto from "../Components/BackgroundPhoto";

export default function Legals({ history }) {
  document.title = "Onboarding";

  const [accountType, setAccountType] = useState(null);
  const [companyType, setCompanyType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [legals, setLegals] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (isSiteBuilder()) {
      setTimeout(() => {
        setAccountType("Personal");
        setCompanyType(null);
        setLegals({ Personal: "https://google.com/" });
        setLoading(false);
      }, 2000);
      return;
    }

    window.OrendaGetResponse(
      { event_name: "page load - legals" },
      (response) => {
        setAccountType(response.account_details.account_type);
        setCompanyType(response.account_details.company_type);
        setLegals(response.termsAndConditions);
        setLoading(false);
      },
      false
    );
    return;
  }, []);

  useEffect(() => {
    if (!submitted) return;
    if (isSiteBuilder()) return;
    window.OrendaGetResponse(
      { event_name: "accept legals" },
      () => {
        goToScreen(null, ""); // no history to make the screen reload
      },
      false
    );
    return;
  }, [submitted]);

  if (loading) return <Loader />;

  if (submitted)
    return (
      <BackgroundPhoto>
        <h5>Creating your account...</h5>
      </BackgroundPhoto>
    );

  return (
    <div className="orenda-frontend">
      <TermsAndConditions
        companyType={companyType}
        accountType={accountType}
        legals={legals}
        submitLegals={() => setSubmitted(true)}
      />
    </div>
  );
}
